export { default, getNodeText } from './useRichTextTableOfContent';